import * as React from "react";

import { UserAgreementLinks } from "./UserAgreementLinks";

import { Trans } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

export const DashboardUserAgreement: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  return (
    <DashboardTypography variant="caption" vibe="text-form-quiet">
      <Trans space="donationForm" i18nKey="userAgreement.fullText" components={UserAgreementLinks({})} />
    </DashboardTypography>
  );
};
